/**
 * @generated SignedSource<<d0d2575a18eee022b02fc702427af645>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type twoPostMagSectionTopWidgetArticles$data = ReadonlyArray<{
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"postMagazineSectionWidgetTwoContent">;
  };
  readonly " $fragmentType": "twoPostMagSectionTopWidgetArticles";
}>;
export type twoPostMagSectionTopWidgetArticles$key = ReadonlyArray<{
  readonly " $data"?: twoPostMagSectionTopWidgetArticles$data;
  readonly " $fragmentSpreads": FragmentRefs<"twoPostMagSectionTopWidgetArticles">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "twoPostMagSectionTopWidgetArticles",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "postMagazineSectionWidgetTwoContent"
            }
          ],
          "type": "Content",
          "abstractKey": "__isContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemsEdge",
  "abstractKey": null
};

(node as any).hash = "e9313b26c80eabba70d7695548bce123";

export default node;
